import i18next from "i18next";

/**
 * Resolve a custom-question string outside React render (class components,
 * SurveyJS callbacks). React function components should prefer useTranslation().
 * Keys are relative to the `customQuestions` namespace, e.g.
 * tQuestion("driversLicenseScanner.scanButton").
 */
export const tQuestion = (
  key: string,
  opts?: Record<string, unknown>,
): string =>
  i18next.t(key, { ns: "customQuestions", lng: i18next.language, ...opts });
